module.exports = __webpack_public_path__ + "media/images/top/etc-card-3-d7a13ce614ba31078a1d0e3c246a0b7d.jpg";